/* eslint-disable array-callback-return, eqeqeq */
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

import HR from "./tv_heart_rate";
import BR from "./tv_breathing_rate";
import SPO2 from "./tv_spo2";
import PR from "./tv_pr";
import SQ from "./tv_signal_quality";
import AHI from "./tv_ahi";
import MOV from "./tv_body_movement";
import RII from "./tv_rii";
import SE from "./tv_se";
import ODI from "./tv_odi";

import bp from "./tv_bp";
import body_temp from "./tv_body_temp";
import blood_sugar from "./tv_blood_sugar";
import weight from "./tv_wt";

dayjs.extend(utc);

var max, min;
const options = {
  BR,
  HR,
  SPO2,
  PR,
  SQ,
  AHI,
  MOV,
  RII,
  SE,
  ODI,
  bp,
  body_temp,
  blood_sugar,
  weight,
};

export const get_chart_options = ({
  kpi_id,
  tv_analytics,
  syncExtremes,
  height,
  zoom_type,
  customTimeRange,
  setCustomTimeRange,
  vital_parameters,
  show_plotbands,
}) => {
  if (tv_analytics && tv_analytics.length === 0) {
    return;
  }

  let data = {};
  let moderateMin,
    moderateMax,
    severeMin,
    severeMax,
    moderateMinF,
    moderateMaxF,
    moderateMinS,
    moderateMaxS,
    severeMinF,
    severeMaxF,
    severeMinS,
    severeMaxS;
  if (["BR"].indexOf(kpi_id) > -1) {
    data = {
      boxplot: [],
      median: [],
    };

    Object.keys(tv_analytics).forEach((d) => {
      data.boxplot.push([
        tv_analytics[d].date,
        Number(tv_analytics[d].min),
        Number(tv_analytics[d].lowerPercentile),
        Number(tv_analytics[d].medianPercentile),
        Number(tv_analytics[d].upperPercentile),
        Number(tv_analytics[d].max),
      ]);
    });
    Object.keys(tv_analytics).forEach((d) => {
      if (tv_analytics[d].medianPercentile) {
        data.median.push([
          tv_analytics[d].date,
          Number(tv_analytics[d].medianPercentile),
        ]);
      }
    });

    if (vital_parameters && vital_parameters.br) {
      moderateMinF = Number(vital_parameters.br.modFromF);
      moderateMaxF = Number(vital_parameters.br.modToF);
      moderateMinS = Number(vital_parameters.br.modFromS);
      moderateMaxS = Number(vital_parameters.br.modToS);
      severeMinF = Number(vital_parameters.br.sevFromF);
      severeMaxF = Number(vital_parameters.br.sevToF);
      severeMinS = Number(vital_parameters.br.sevFromS);
      severeMaxS = Number(vital_parameters.br.sevToS);
    }
  } else if (["HR"].indexOf(kpi_id) > -1) {
    data = {
      boxplot: [],
      median: [],
    };

    Object.keys(tv_analytics).forEach((d) => {
      data.boxplot.push([
        tv_analytics[d].date,
        Number(tv_analytics[d].min),
        Number(tv_analytics[d].lowerPercentile),
        Number(tv_analytics[d].medianPercentile),
        Number(tv_analytics[d].upperPercentile),
        Number(tv_analytics[d].max),
      ]);
    });
    Object.keys(tv_analytics).forEach((d) => {
      if (tv_analytics[d].medianPercentile) {
        data.median.push([
          tv_analytics[d].date,
          Number(tv_analytics[d].medianPercentile),
        ]);
      }
    });
  } else if (["SPO2"].indexOf(kpi_id) > -1) {
    data = {
      boxplot: [],
      median: [],
    };

    Object.keys(tv_analytics).forEach((d) => {
      data.boxplot.push([
        tv_analytics[d].date,
        Number(tv_analytics[d].min),
        Number(tv_analytics[d].lowerPercentile),
        Number(tv_analytics[d].medianPercentile),
        Number(tv_analytics[d].upperPercentile),
        Number(tv_analytics[d].max),
      ]);
    });
    Object.keys(tv_analytics).forEach((d) => {
      if (tv_analytics[d].medianPercentile) {
        data.median.push([
          tv_analytics[d].date,
          Number(tv_analytics[d].medianPercentile),
        ]);
      }
    });
    if (vital_parameters && vital_parameters.spo2) {
      moderateMin = Number(vital_parameters.spo2.modFrom);
      moderateMax = Number(vital_parameters.spo2.modTo);
      severeMin = Number(vital_parameters.spo2.sevFrom);
      severeMax = Number(vital_parameters.spo2.sevTo);
    }
  } else if (["PR"].indexOf(kpi_id) > -1) {
    data = {
      boxplot: [],
      median: [],
    };

    Object.keys(tv_analytics).forEach((d) => {
      data.boxplot.push([
        tv_analytics[d].date,
        Number(tv_analytics[d].min),
        Number(tv_analytics[d].lowerPercentile),
        Number(tv_analytics[d].medianPercentile),
        Number(tv_analytics[d].upperPercentile),
        Number(tv_analytics[d].max),
      ]);
    });
    Object.keys(tv_analytics).forEach((d) => {
      if (tv_analytics[d].medianPercentile) {
        data.median.push([
          tv_analytics[d].date,
          Number(tv_analytics[d].medianPercentile),
        ]);
      }
    });
    if (vital_parameters && vital_parameters.pr) {
      moderateMinF = Number(vital_parameters.pr.modFromF);
      moderateMaxF = Number(vital_parameters.pr.modToF);
      moderateMinS = Number(vital_parameters.pr.modFromS);
      moderateMaxS = Number(vital_parameters.pr.modToS);
      severeMinF = Number(vital_parameters.pr.sevFromF);
      severeMaxF = Number(vital_parameters.pr.sevToF);
      severeMinS = Number(vital_parameters.pr.sevFromS);
      severeMaxS = Number(vital_parameters.pr.sevToS);
    }
  } else if (["SQ"].indexOf(kpi_id) > -1) {
    data = {
      sq_points: [],
      ts_points: [],
      tb_points: [],
      tbr_points: [],
    };
    Object.keys(tv_analytics).forEach((d) => {
      data.sq_points.push([
        tv_analytics[d].date,
        Number(tv_analytics[d].good_signal_duration),
      ]);
      data.ts_points.push([
        tv_analytics[d].date,
        Number(tv_analytics[d].total_sleep_time),
      ]);
      data.tb_points.push([
        tv_analytics[d].date,
        Number(tv_analytics[d].total_bed_time),
      ]);
      data.tbr_points.push([
        tv_analytics[d].date,
        Number(tv_analytics[d].total_breathing_time),
      ]);
    });
  } else if (["RII"].indexOf(kpi_id) > -1) {
    data = {
      points: [],
    };
    Object.keys(tv_analytics).forEach((d) => {
      data.points.push([tv_analytics[d].date, Number(tv_analytics[d].rii)]);
    });
  } else if (["ODI"].indexOf(kpi_id) > -1) {
    data = {
      points: [],
    };
    Object.keys(tv_analytics).forEach((d) => {
      data.points.push([
        tv_analytics[d].date,
        Number(tv_analytics[d].odi_value),
      ]);
    });
  } else if (["SE"].indexOf(kpi_id) > -1) {
    data = {
      points: [],
    };
    Object.keys(tv_analytics).forEach((d) => {
      data.points.push([
        tv_analytics[d].date,
        tv_analytics[d].sleep_efficiency,
      ]);
    });
  } else if (["AHI"].indexOf(kpi_id) > -1) {
    data = {
      points: [],
    };

    Object.keys(tv_analytics).forEach((d) => {
      data.points.push([
        tv_analytics[d].date,
        Number(tv_analytics[d].ahi_value),
      ]);
    });
  } else if (["MOV"].indexOf(kpi_id) > -1) {
    data = {
      points: [],
    };

    Object.keys(tv_analytics).forEach((d) => {
      data.points.push([tv_analytics[d].date, Number(tv_analytics[d].ri)]);
    });
  } else if (["bp"].indexOf(kpi_id) > -1) {
    data = {
      data_lower: [],
      data_upper: [],
      // points_lower: [],
      // points_upper: [],
    };

    Object.keys(tv_analytics).forEach((d, i) => {
      if (
        tv_analytics[d].lower_bp ||
        i === 0 ||
        i === tv_analytics.length - 1
      ) {
        if (i === 0 || i === tv_analytics.length - 1) {
          data.data_lower.push([tv_analytics[d].date, NaN, NaN, NaN, NaN, NaN]);
        } else {
          data.data_lower.push([
            tv_analytics[d].date,
            Number(tv_analytics[d].lower_bp.min),
            Number(tv_analytics[d].lower_bp.min),
            Number(tv_analytics[d].lower_bp.mean) === 0
              ? NaN
              : Number(tv_analytics[d].lower_bp.mean),
            Number(tv_analytics[d].lower_bp.min),
            Number(tv_analytics[d].lower_bp.max),
          ]);
        }
      }
    });
    // Object.keys(tv_analytics).forEach((d, i) => {
    //     if( tv_analytics[d].lower_bp || i === 0 || i === (tv_analytics.length - 1)) {
    //         if( i === 0 || i === (tv_analytics.length - 1) ) {
    //             data.points_lower.push([tv_analytics[d].date, NaN]);
    //         }
    //         else if( i === 1) {
    //             data.points_lower.push([tv_analytics[d].date, 84]);
    //         }
    //         else {
    //             data.points_lower.push([tv_analytics[d].date,
    //                 Number(tv_analytics[d].lower_bp.mean) === 0 ? NaN: Number(tv_analytics[d].lower_bp.mean)]);
    //         }
    //     }
    //     if( tv_analytics[d].upper_bp || i === 0 || i === (tv_analytics.length - 1)) {
    //         if( i === 0 || i === (tv_analytics.length - 1) ) {
    //             data.points_upper.push([tv_analytics[d].date, NaN]);
    //         }
    //         else if( i === 1) {
    //             data.points_upper.push([tv_analytics[d].date, 125 ]);
    //         }
    //         else {
    //             data.points_upper.push([tv_analytics[d].date,
    //                 Number(tv_analytics[d].upper_bp.mean) === 0 ? NaN: Number(tv_analytics[d].upper_bp.mean)]);
    //         }
    //     }
    // });

    Object.keys(tv_analytics).forEach((d, i) => {
      if (
        tv_analytics[d].upper_bp ||
        i === 0 ||
        i === tv_analytics.length - 1
      ) {
        if (i === 0 || i === tv_analytics.length - 1) {
          data.data_upper.push([tv_analytics[d].date, NaN, NaN, NaN, NaN, NaN]);
        } else {
          data.data_upper.push([
            tv_analytics[d].date,
            Number(tv_analytics[d].upper_bp.min),
            Number(tv_analytics[d].upper_bp.min),
            Number(tv_analytics[d].upper_bp.mean) === 0
              ? NaN
              : Number(tv_analytics[d].upper_bp.mean),
            Number(tv_analytics[d].upper_bp.min),
            Number(tv_analytics[d].upper_bp.max),
          ]);
        }
      }
    });
  } else if (["blood_sugar"].indexOf(kpi_id) > -1) {
    data = {
      boxplot: [],
      median: [],
    };
    Object.keys(tv_analytics).forEach((d) => {
      data.boxplot.push([
        tv_analytics[d].date,
        Number(tv_analytics[d].min),
        Number(tv_analytics[d].min),
        Number(tv_analytics[d].mean) === 0 ? NaN : Number(tv_analytics[d].mean),
        Number(tv_analytics[d].min),
        Number(tv_analytics[d].max),
      ]);
    });
    Object.keys(tv_analytics).forEach((d) => {
      if (tv_analytics[d].mean) {
        data.median.push([
          tv_analytics[d].date,
          Number(tv_analytics[d].mean) === 0
            ? NaN
            : Number(tv_analytics[d].mean),
        ]);
      }
    });
  } else if (["body_temp"].indexOf(kpi_id) > -1) {
    data = {
      boxplot: [],
      median: [],
    };
    Object.keys(tv_analytics).forEach((d) => {
      data.boxplot.push([
        tv_analytics[d].date,
        Number(tv_analytics[d].min),
        Number(tv_analytics[d].min),
        Number(tv_analytics[d].mean) === 0 ? NaN : Number(tv_analytics[d].mean),
        Number(tv_analytics[d].min),
        Number(tv_analytics[d].max),
      ]);
    });
    Object.keys(tv_analytics).forEach((d) => {
      if (tv_analytics[d].mean) {
        data.median.push([
          tv_analytics[d].date,
          Number(tv_analytics[d].mean) === 0
            ? NaN
            : Number(tv_analytics[d].mean),
        ]);
      }
    });
  } else if (["weight"].indexOf(kpi_id) > -1) {
    data = {
      boxplot: [],
      median: [],
    };
    Object.keys(tv_analytics).forEach((d) => {
      data.boxplot.push([
        tv_analytics[d].date,
        Number(tv_analytics[d].min),
        Number(tv_analytics[d].min),
        Number(tv_analytics[d].mean) === 0 ? NaN : Number(tv_analytics[d].mean),
        Number(tv_analytics[d].min),
        Number(tv_analytics[d].max),
      ]);
    });
    Object.keys(tv_analytics).forEach((d) => {
      if (tv_analytics[d].mean) {
        data.median.push([
          tv_analytics[d].date,
          Number(tv_analytics[d].mean) === 0
            ? NaN
            : Number(tv_analytics[d].mean),
        ]);
      }
    });
  }

  let opt = options[kpi_id]({ data });

  let tickAmount = 3;
  if (["MOV"].indexOf(kpi_id) > -1) {
    tickAmount = 2;
  }

  opt = {
    ...opt,
    title: {
      ...opt.title,
      id: kpi_id,
    },
    xAxis: {
      ...opt.xAxis,
      scrollbar: {
        enabled: false,
      },
      startOnTick: false,
      endOnTick: false,
      showLastLabel: true,
      events: {
        setExtremes: syncExtremes,
      },
    },
    yAxis: {
      ...opt.yAxis,
      opposite: false,
      tickAmount: tickAmount,
      startOnTick: false,
      endOnTick: false,
      showLastLabel: true,
      labels: {
        ...opt.yAxis.labels,
        y: 5,
      },
      plotBands: [
        {
          from: moderateMin ? moderateMin : moderateMinF,
          to: moderateMax ? moderateMax : moderateMaxF,
          color: show_plotbands ? "#fcffbd" : "white",
          label: {
            text: "",
          },
        },
        {
          from: severeMin ? severeMin : severeMinF,
          to: severeMax ? severeMax : severeMaxF,
          color: show_plotbands ? "#ffbdbd" : "white",
          label: {
            text: "",
          },
        },
        {
          from: moderateMinS ? moderateMinS : "",
          to: moderateMaxS ? moderateMaxS : "",
          color: show_plotbands ? "#fcffbd" : "white",
          label: {
            text: "",
          },
        },
        {
          from: severeMinS ? severeMinS : "",
          to: severeMaxS ? severeMaxS : "",
          color: show_plotbands ? "#ffbdbd" : "white",
          label: {
            text: "",
          },
        },
      ],
    },
    chart: {
      ...opt.chart,
      zoomType: zoom_type,
      selection: true,
      height,
      events: {
        ...opt.chart.events,
        redraw: function() {},
        load: function(e) {
          if (customTimeRange && customTimeRange.length === 2) {
            let axis = e.target.xAxis[0];
            axis.setExtremes(min, max);
          }

          let containerHeight = window.innerHeight - 200;
          let chartElements = document.querySelectorAll(".chart-block");
          let expChartElements = document.querySelectorAll(
            ".chart-block.expanded"
          );
          let chartHeight;

          if (expChartElements && expChartElements.length) {
            if (expChartElements.length === 1) {
              chartHeight = containerHeight - 10;
            } else if (expChartElements.length === 2) {
              chartHeight = (containerHeight - 20) / 2;
            } else if (expChartElements.length === 3) {
              chartHeight = (containerHeight - 30) / 3;
            } else if (
              expChartElements.length === 4 ||
              expChartElements.length >= 4
            ) {
              chartHeight = (containerHeight - 40) / 4;
            }
          } else {
            if (chartElements.length > 2) {
              chartHeight = (containerHeight - 20) / 2;
            } else {
              chartHeight = containerHeight - 10;
            }
          }

          for (let i = 0; i < chartElements.length; i++) {
            chartElements[i].style.height = chartHeight + "px";
          }

          if (e.target) {
            e.target.reflow();
          }
        },

        selection: function(event) {
          max = event.target.xAxis[0].max;
          min = event.target.xAxis[0].min;
          if (event.xAxis) {
            setCustomTimeRange([event.xAxis[0].max, event.xAxis[0].min]);
          }
        },
      },
      resetZoomButton: {
        theme: {
          display: "none",
        },
      },
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      ...opt.tooltip,
      shared: true,
      formatter: function(obj) {
        const k = obj.chart.renderTo.id.split("-").pop();
        let tip = "";
        const y = Math.floor(this.y * 100) / 100;
        const x = dayjs.utc(this.x).format("DD MMM YYYY");
        if (this.points && this.points[0].series) {
          if (["SQ", "MOV"].indexOf(k) > -1) {
            const g = Math.floor(this.points[0].y * 100) / 100;
            const s = Math.floor(this.points[1].y * 100) / 100;
            const b = Math.floor(this.points[2].y * 100) / 100;
            const br = Math.floor(this.points[3].y * 100) / 100;

            tip = `<span style="color:blue">\u25CF</span><b>Total Bed Time</b>: ${b} <br> <span style="color:dark">\u25CF</span><b>Good Signal Duration</b>: ${g} <br> <span style="color:orange">\u25CF</span><b>Total Sleep Time</b>: ${s} <br> <span style="color:green">\u25CF</span><b>Total Breathing Time</b>: ${br} <br> at ${x}`;
          } else if (["RII"].indexOf(k) > -1) {
            tip = `<b>Value</b>: ${y} at ${x}`;
          } else if (["SE"].indexOf(k) > -1) {
            tip = `<b>Value</b>: ${y} % at ${x}`;
          } else if (["AHI"].indexOf(k) > -1) {
            tip = `<b>Value</b>: ${y} at ${x}`;
          } else if (["ODI"].indexOf(k) > -1) {
            tip = `<b>Value</b>: ${y} at ${x}`;
          } else if (["weight"].indexOf(k) > -1) {
            tip = ` <b>Weight </b> <br>
                         <b>Max:</b> ${this.points[0].point.high} KG <br>
                         ${
                           this.points[0].point.median
                             ? "<b>Mean:</b>" +
                               this.points[0].point.median +
                               "KG <br>"
                             : " "
                         }
                         <b>Min:</b> ${this.points[0].point.low} KG`;
          } else if (["blood_sugar"].indexOf(k) > -1) {
            tip = ` <b>Blood Sugar </b> <br>
                         <b>Max:</b> ${this.points[0].point.high} mg dL <br>
                         ${
                           this.points[0].point.median
                             ? "<b>Mean:</b>" +
                               this.points[0].point.median +
                               "mg dL <br>"
                             : " "
                         }
                         <b>Min:</b> ${this.points[0].point.low} mg dL`;
          } else if (["body_temp"].indexOf(k) > -1) {
            tip = ` <b>Body Temperatue </b> <br>
                         <b>Max:</b> ${this.points[0].point.high} deg C <br>
                         ${
                           this.points[0].point.median
                             ? "<b>Mean:</b>" +
                               this.points[0].point.median +
                               "deg C  <br>"
                             : " "
                         }
                         <b>Min:</b> ${this.points[0].point.low} deg C `;
          } else if (["bp"].indexOf(k) > -1) {
            // this.points[1].point.median is mean
            tip = `<b>Systolic </b> <br> 
                         <b>Max:</b> ${this.points[1].point.high} mm Hg <br>
                         ${
                           this.points[1].point.median
                             ? "<b>Mean:</b>" +
                               this.points[1].point.median +
                               "mm Hg <br>"
                             : " "
                         }
                         <b>Min:</b> ${this.points[1].point.low} mm Hg <br>
                         <b>Diastolic </b> <br>
                         <b>Max:</b> ${this.points[0].point.high} mm Hg <br>
                         ${
                           this.points[0].point.median
                             ? "<b>Mean:</b>" +
                               this.points[0].point.median +
                               "mm Hg <br>"
                             : " "
                         }
                         <b>Min:</b> ${this.points[0].point.low} mm Hg <br>
                         at ${dayjs.utc(this.x).format("hh:mm A, DD MMM")}`;
          } else {
            let high = this.points[0].point.high;
            if (high && !(high % 1 === 0)) {
              high = high.toFixed(2);
            }
            let upper = this.points[0].point.q3;
            if (upper && !(upper % 1 === 0)) {
              upper = upper.toFixed(2);
            }
            let median = this.points[0].point.median;
            if (median && !(median % 1 === 0)) {
              median = median.toFixed(2);
            }
            let lower = this.points[0].point.q1;
            if (lower && !(lower % 1 === 0)) {
              lower = lower.toFixed(2);
            }
            let low = this.points[0].point.low;
            if (low && !(low % 1 === 0)) {
              low = low.toFixed(2);
            }
            tip = `<b>Max</b>: ${high} <br> <b>UpperPercentile</b>:${
              isNaN(upper) ? "N/A" : upper
            } <br> <b>Median</b>: ${
              isNaN(median) ? "N/A" : median
            }  <br> <b>LowerPercentile</b>: ${
              isNaN(lower) ? "N/A" : lower
            } <br> <b>Min</b>: ${low} <br>  at ${x}`;
          }
        }
        return tip;
      },
    },
    plotOptions: {
      ...opt.plotOptions,
      series: {
        events: {
          click: function() {},
        },
      },
    },
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 800,
          },
          chartOptions: {
            rangeSelector: {
              inputEnabled: false,
            },
          },
        },
      ],
    },
    rangeSelector: {
      enabled: false,
    },
    scrollbar: {
      enabled: false,
    },
  };

  return opt;
};

export default options;
